import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Features from "../components/landing/Features";
import { AppPreview, Packages, Footer } from "../components/landing/Sections";

const LandingPage = () => {
  const navigate = useNavigate();

  const scrollToPackages = () => {
    document.getElementById("paketler")?.scrollIntoView({ behavior: "smooth" });
  };

  const openPackage = (pkg) => {
    navigate(`/tanitim/kayit?package=${pkg.id}`);
  };

  return (
    <div className="relative min-h-screen text-neutral-900 antialiased">
      <div
        aria-hidden
        data-testid="site-background"
        className="fixed inset-0 -z-10 bg-black bg-cover bg-center"
        style={{ backgroundImage: "url(/site-bg.jpeg)" }}
      />
      <Navbar onJoin={scrollToPackages} />
      <Hero />
      <Features />
      <AppPreview />
      <Packages onSelect={openPackage} />
      <Footer />
    </div>
  );
};

export default LandingPage;
